/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useCompanyData } from "hooks/use-company-data"

function Seo({ description, lang, meta, title, schema, location, image }) {
    //  const site = useSiteData();

    const company = useCompanyData()
    const url = location ? location.href : ""
    //console.log(meta)
    let defaultjsonschema = {}

    schema = schema ?? defaultjsonschema
    const metaDescription = description || company.description
    const defaultTitle = company.name
    // console.log(metaDescription)
    //  let originalmeta = [
    let metadata = [
        {
            name: `description`,
            content: metaDescription,
        },
        {
            property: `og:title`,
            content: title,
        },
        {
            property: `og:description`,
            content: metaDescription,
        },
        {
            property: `og:type`,
            content: meta ? meta.OG_type : `article`,
        },
        {
            name: `og:site_name`,
            content: company.website,
        },
        {
            name: "og:url",
            content: url,
        },

        {
            name: `twitter:card`,
            content: `summary`,
        },
        {
            name: `twitter:creator`,
            content: company.name || ``,
        },
        {
            name: `twitter:title`,
            content: title,
        },
        {
            name: `twitter:description`,
            content: metaDescription,
        },
    ]

    let set = new Set()
    /* need to create new field for og image*/
    if (image !== "" && image !== null) {
        metadata.push(
            {
                name: `twitter:image`,
                content: `${
                    location ? location.origin : company.website
                }${image}`,
            },
            {
                property: `og:image`,
                content: `${
                    location ? location.origin : company.website
                }${image}`,
            },
            {
                property: "og:image:alt",
                content: title,
            },
            {
                property: "og:image:type",
                content: "image/jpeg",
            }
        )
    }

    // meta = meta.map((x) => {
    //   return JSON.parse(`{"${x.type}":"${x.title}","content":"${x.description}"}`)
    // })
    // console.log(meta)

    // const mergedArray = [...meta, ...originalmeta];
    // console.log(mergedArray)

    // let unionArray = mergedArray.filter(item => {

    //     let value = item.name || item.property
    //     if (value) {
    //         if (!set.has(value)) {
    //             set.add(value);
    //             return true;
    //           }
    //           return false;
    //     }
    //   }, set);

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title || ""}
            titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
            //  meta={unionArray}
            meta={metadata}
        >
            <link rel="canonical" href={url} />
            <link rel="stylesheet" href="https://use.typekit.net/wah4xoi.css" />
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>
    )
}

Seo.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
}

Seo.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default Seo
